import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppState {
  showDebug: boolean
  setShowDebug: (showDebug: boolean) => void
}

export const useStore = create<AppState>()(
  persist(
    (set) => ({
      showDebug: false,
      setShowDebug: (showDebug) => set({ showDebug })
    }),
    {
      name: 'app-storage'
    }
  )
)
